// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3QvFY","actionsCol":"EnrolledClinics_actionsCol__1yKEk"};